/* REVIVAL FESTIVAL: 今売れている組み合わせ（sections/rf-pairs.liquid）
 * 公開集計 API の snapshot.pairs（集計値のみ）を読み、期間ごとの TOP3 を表示する。
 * 人数の絞り込み（最少人数）は Worker 側で済んでいるので、ここでは API の順位をそのまま表示する。
 * 他の rf-* の JS とは独立。ページ上のどの要素も書き換えず、このセクションの中だけを描画する。 */
(function () {
  'use strict';
  if (window.__rfPairs) return; window.__rfPairs = true;
  var GROUPS = ['eco', 'cooler', 'furoshiki'];
  var CROWN = '<svg class="rf-pairs__crown" viewBox="0 0 60 34" aria-hidden="true" focusable="false"><path d="M6 30 L3 9 L17 19 L30 4 L43 19 L57 9 L54 30 Z"/><circle cx="3" cy="8" r="3"/><circle cx="30" cy="4" r="3.4"/><circle cx="57" cy="8" r="3"/><rect x="6" y="28" width="48" height="5" rx="1.5"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readJson(root, sel) { try { var el = root.querySelector(sel); return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function fmtTime(iso) {
    var d = new Date(iso); if (isNaN(d)) return '';
    var j = new Date(d.getTime() + 9 * 3600000); // 日本時間で表示
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return (j.getUTCMonth() + 1) + '/' + j.getUTCDate() + ' ' + j.getUTCHours() + ':' + p(j.getUTCMinutes());
  }

  function init(root) {
    var items = readJson(root, '[data-rf-pairs-items]'), text = readJson(root, '[data-rf-pairs-text]');
    var list = root.querySelector('[data-rf-pairs-list]'), state = root.querySelector('[data-rf-pairs-state]');
    var caption = root.querySelector('[data-rf-pairs-caption]'), updated = root.querySelector('[data-rf-pairs-updated]');
    var upd = root.getAttribute('data-updated') || '', groupNames = text.groups || {};
    var cur = 'all', data = null, failed = false;
    var exBox = root.querySelector('[data-rf-pairs-ex]'), exList = root.querySelector('[data-rf-pairs-ex-list]');

    // 「A×B」の柄名は「A」「×B」のかたまりごとに折り返す（スマホで文字の途中で切れないように）
    function product(side) {
      side = side || {};
      var g = GROUPS.indexOf(side.group) >= 0 ? side.group : '', it = items[side.key] || {};
      var name = it.name || side.key || '', note = it.note || '', cat = groupNames[g] || '';
      var img = g ? ((it.img || {})[g] || '') : '';
      return '<div class="rf-pairs__prod rf-pairs__prod--' + (g || 'none') + '">' +
        '<div class="rf-pairs__thumb">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(name + note + (cat ? '（' + cat + '）' : '')) + '" width="360" height="360" loading="lazy" decoding="async">' : '') + '</div>' +
        '<p class="rf-pairs__name">' + String(name).split('×').map(function (t, i) { return '<span class="rf-pairs__seg">' + (i ? '×' : '') + esc(t) + '</span>'; }).join('') + (note ? '<span class="rf-pairs__name-note">' + esc(note) + '</span>' : '') + '</p>' +
        (cat ? '<p class="rf-pairs__cat">' + esc(cat) + '</p>' : '') + '</div>';
    }

    // 2026-10-04：セットをまとめてカートに追加するボタン。商品ごとのバリエーションID（在庫あり）は Liquid が data-rf-pairs-items の vid に入れている
    function cartIds(sides) {
      var ids = [];
      for (var i = 0; i < sides.length; i++) {
        var s = sides[i] || {}, it = items[s.key] || {}, id = Number(((it.vid || {})[s.group]) || 0);
        if (!id) return null; // 在庫切れ・商品が見つからない
        ids.push(id);
      }
      return ids;
    }
    function cartBtn(sides) {
      if (!text.cart_on) return '';
      var ids = cartIds(sides);
      return '<div class="rf-pairs__cart">' +
        (ids ? '<button type="button" class="rf-pairs__add" data-rf-pairs-add="' + ids.join(',') + '">' + esc(text.cart_label || '') + '</button>'
             : '<button type="button" class="rf-pairs__add" disabled>' + esc(text.cart_label || '') + '</button><p class="rf-pairs__added rf-pairs__added--ng">' + esc(text.cart_soldout || '') + '</p>') +
        '<p class="rf-pairs__added" data-rf-pairs-msg role="status" hidden></p></div>';
    }

    function joinItems(items) {
      return items.map(product).join('<span class="rf-pairs__x" aria-hidden="true">×</span><span class="rf-pairs__sr">と</span>');
    }
    // 3個セット以上の例（全期間・API が2人以上に絞り済み）。期間タブとは無関係に同じ内容
    function renderExamples() {
      if (!exBox || !exList) return;
      var ex = data && data.pairs && Array.isArray(data.pairs.examples) ? data.pairs.examples.filter(function (x) { return x && Array.isArray(x.items) && x.items.length >= 3; }) : [];
      exBox.hidden = !ex.length;
      exList.innerHTML = ex.map(function (x) {
        var n = Number(x.buyers); n = isFinite(n) ? n : 0;
        return '<li class="rf-pairs__ex-item"><p class="rf-pairs__ex-size">' + x.items.length + esc(text.set_label || '') + '</p>' +
          '<div class="rf-pairs__pair rf-pairs__pair--' + x.items.length + '">' + joinItems(x.items) + '</div>' +
          (text.show_ex_buyers ? '<p class="rf-pairs__buyers"><b>' + n.toLocaleString('ja-JP') + '</b>' + esc(text.buyers || '') + '</p>' : '') + cartBtn(x.items) + '</li>';
      }).join('');
    }

    function render() {
      caption.textContent = (text.captions || {})[cur] || '';
      if (!data) { list.innerHTML = ''; state.hidden = false; state.textContent = root.getAttribute(failed ? 'data-text-error' : 'data-text-loading') || ''; updated.textContent = ''; return; }
      updated.textContent = data.updated_at ? fmtTime(data.updated_at) + ' ' + upd : '';
      renderExamples();
      // sets（ちょうどその組み合わせ・2〜4個）を優先。古い API で sets が無いときは ranking（2商品の組 a/b）
      var p = (data.pairs || {})[cur] || {};
      var rows = (Array.isArray(p.sets) ? p.sets.map(function (x) { return { items: x.items || [], buyers: x.buyers }; })
        : (Array.isArray(p.ranking) ? p.ranking.map(function (x) { return { items: [x.a, x.b], buyers: x.buyers }; }) : [])).slice(0, 3);
      if (!rows.length) { list.innerHTML = ''; state.hidden = false; state.textContent = root.getAttribute('data-text-empty') || ''; return; }
      state.hidden = true;
      list.innerHTML = rows.map(function (r, i) {
        var rank = i + 1, tier = rank === 1 ? 'gold' : rank === 2 ? 'silver' : 'bronze';
        var n = Number(r.buyers); n = isFinite(n) ? n : 0;
        return '<li class="rf-pairs__item rf-pairs__item--' + tier + '">' +
          '<div class="rf-pairs__rank">' + CROWN + '<span class="rf-pairs__num">' + rank + '</span><span class="rf-pairs__sr">' + esc(text.rank || '') + '</span></div>' +
          '<div class="rf-pairs__body"><div class="rf-pairs__pair' + (r.items.length > 2 ? ' rf-pairs__pair--' + r.items.length : '') + '">' + joinItems(r.items) + '</div>' +
          '<p class="rf-pairs__buyers"><b>' + n.toLocaleString('ja-JP') + '</b>' + esc(text.buyers || '') + '</p>' + cartBtn(r.items) + '</div></li>';
      }).join('');
    }

    // カートに追加（各1個ずつ）。追加に成功したらカートページへ移動する（失敗時はこのページにエラーを表示）
    var adding = false;
    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-rf-pairs-add]') : null;
      if (!b || adding) return;
      var qty = {};
      b.getAttribute('data-rf-pairs-add').split(',').forEach(function (id) { id = Number(id); if (id) qty[id] = (qty[id] || 0) + 1; });
      var list2 = Object.keys(qty).map(function (id) { return { id: Number(id), quantity: qty[id] }; });
      if (!list2.length) return;
      var msg = b.parentNode.querySelector('[data-rf-pairs-msg]'), label = b.textContent;
      adding = true; b.disabled = true; b.textContent = text.cart_busy || label; if (msg) msg.hidden = true;
      var bubble = document.getElementById('cart-icon-bubble');
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: list2, sections: bubble ? 'cart-icon-bubble' : undefined }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) throw new Error((res.j && (res.j.description || res.j.message)) || 'error');
          if (msg) { msg.className = 'rf-pairs__added'; msg.innerHTML = '✓ ' + esc(text.cart_done || '') + ' <a href="' + esc(text.cart_url || '/cart') + '">' + esc(text.cart_view || '') + ' →</a>'; msg.hidden = false; }
          var html = res.j.sections && res.j.sections['cart-icon-bubble'];
          if (bubble && html) { var sec = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section'); if (sec) bubble.innerHTML = sec.innerHTML; }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          // 戻るボタンでこのページに戻ったとき、ボタンを元の状態に戻す
          window.addEventListener('pageshow', function (ev) { if (ev.persisted) { adding = false; b.disabled = false; b.textContent = label; if (msg) msg.hidden = true; } }, { once: true });
          window.location.href = text.cart_url || '/cart';
          return 'go';
        })
        .catch(function (err) {
          if (msg) { msg.className = 'rf-pairs__added rf-pairs__added--ng'; msg.textContent = (err && err.message && err.message !== 'error' && err.message !== 'Failed to fetch') ? err.message : (text.cart_error || ''); msg.hidden = false; setTimeout(function () { msg.hidden = true; }, 12000); }
        })
        .then(function (st) { if (st === 'go') return; adding = false; b.disabled = false; b.textContent = label; });
    });

    var btns = Array.prototype.slice.call(root.querySelectorAll('.rf-pairs__period'));
    function select(i) {
      btns.forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); b.tabIndex = j === i ? 0 : -1; });
      cur = btns[i].getAttribute('data-period'); render();
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(i); });
      b.addEventListener('keydown', function (e) {
        var k = e.key, n = k === 'ArrowRight' ? i + 1 : k === 'ArrowLeft' ? i - 1 : k === 'Home' ? 0 : k === 'End' ? btns.length - 1 : null;
        if (n === null) return; e.preventDefault(); n = (n + btns.length) % btns.length; select(n); btns[n].focus();
      });
    });

    var url = root.getAttribute('data-url'), every = Math.max(30, Number(root.getAttribute('data-refresh')) || 60) * 1000, timer = null;
    function load() {
      if (!url) { failed = true; render(); return; }
      fetch(url, { credentials: 'omit', cache: 'no-cache' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) { if (!j || !j.pairs) throw new Error('no data'); data = j; failed = false; if (!adding && !root.querySelector('[data-rf-pairs-msg]:not([hidden])')) render(); })
        .catch(function () { failed = !data; render(); });
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(function () { if (!document.hidden) load(); schedule(); }, every); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) load(); });
    render(); load(); schedule();
  }

  function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-rf-pairs]'), function (r) { if (!r.__rfPairs) { r.__rfPairs = true; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start); // テーマエディタ
})();
